<template>
  <div>
    <fieldset>
      <h3 class="modal-title">ADD APPLICATION TO GROUP</h3>
      <b-form-group :class="{'error-input' : $v.application.$error}">
        <label> Application </label>
        <j-single-select
          v-model="application"
          :options="list_application"
          :placeholder="'Select Application'"
          :error-required="false"
          value-format="object"
        />
      </b-form-group>
      <div class="pull-right m__t--20">
        <b-button
          class="btn"
          @click="closeMappingModal">
          Close
        </b-button>
        <b-button
          class="btn"
          variant="primary"
          @click="createMapping">
          Confirm
        </b-button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  validations() {
    return {
      application: { required },
    };
  },
  data() {
    return {
      application: null,
      list_application: [],
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['applications_list']),
  },
  watch: {
    applications_list(val) {
      this.list_application = [];
      val.forEach((lab) => {
        this.list_application.push({
          text: lab.name,
          id: lab.id,
        });
      });
    },
  },
  created() {
    this.getDataApps();
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionCreateGroupRelation', 'actionGetApplicationsList']),

    getDataApps() {
      const parameter = {
        page: 1,
        limit: 10000,
      };
      this.actionGetApplicationsList({ params: parameter });
    },

    closeMappingModal() {
      this.$emit('modal-open', false);
    },

    async createMapping() {
      this.$v.application.$touch();

      if (!this.$v.application.$error) {
        this.$swal({
          title: `Are you sure to mapping application ${this.application.label} ?`,
          text: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            const parameter = {
              application_id: Number(this.application.id),
              group_application_id: Number(this.$route.params.groupId),
            };
            const res = await this.actionCreateGroupRelation(parameter);

            if (!res.error) {
              this.application = null;
              this.$emit('data-created');
              this.$emit('modal-open', false);
              this.$v.application.$reset();
            }
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/setting/jModalMappingAppsGroup.vue